import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ children, location, ...rest }) => {
    return (
        <Route {...rest} children={({ location }) => {
            return localStorage.getItem('profile') ? children : <Redirect to={{ pathname: '/login', state: { from: location } }} />
        }} />
    )
}

export default PrivateRoute